export const SRP_BUS_URL = '/bus/getsearch/v4/?flavour=mobile&vc=latest&query=';
export const SRP_BUS_URL_V4 = '/apis/v4/search/?format=json&flavour=v2';
export const SEAT_LAYOUT_URL = '/apis/v1/seatlayout/?format=json';
export const RATING_REVIEW_URL ='/apis/v1/seatseller/?action=get_tag_reviews&rid=';
export const RED_DEAL_URL = '/bus/getreddealsseatlayout/?flavour=v2&query=';
export const BUS_REVIEW_URL='/bus/busreview/v3/';
export const BUS_PROMO_DISCOUNT_URL='/bus/getpromodiscount/v3/?flavour=v2';
export const BUS_SUBMIT_URL = '/bus/bussubmit/v4/?flavour=v2';
export const BUS_REVIEW_DEPOT_URL='/apis/busreview/v2/';
export const PROMO_URL = '/apis/v2/promo/?flavour=v2';
export const TENTATIVE_URL = '/apis/v2/submitform/?flavour=v2';
export const CANCELLATION_POLICY_URL='/bus/get_cancellation_policy/?bid=';
export const BUS_DETAIL_URL = '/apis/v2/get_bus_detail/?all_data_req=true&bid=';
export const SRP_GOSAFE_URL='/api/v1/smart_engage/get_smart_ads/?context=gnr&flavour=v3&slots=["bus_dweb_srp_gosafe_banner"]&status=LIVE&vertical=bus';
export const REVIEW_GOSAFE_URL='/api/v1/smart_engage/get_smart_ads/?context=gnr&flavour=android&slots=["bus_review_gosafe"]&status=LIVE&vertical=bus';
export const REVIEW_SOCIAL_DISTANCE_URL='/api/v1/smart_engage/get_smart_ads/?context=gnr&flavour=android&slots=["bus_gosafe_social_distance"]&status=LIVE&vertical=bus';
export const BUS_THANKYOU_JOURNEY_DETAIL ="/apis/v2/paymentcallback/";
export const BUS_THANKYOU_STATUS_DETAIL ="/bus/getstatus/";
export const BUS_FEEDBACK_URL="/surveymgmt/v1/surveydata/uniqueId/";
export const BUS_SURVEY_URL="/surveymgmt/v1/commonnps/createDesktopSurvey?lob=Bus&category=Bus_ThankYouPage&org=GI";
export const AUTO_SUGGEST_URL ="/api/v1/bus/giautosuggest/search?version=v2&new=1";
export const goTribeUrlPath = '/loyalty/bookingMessage';
export const BUS_INFO_GET_BUS_DETAILS = '/apis/v1/bus_info/?flavour=v2&action=get_bus_details';
export const SEAT_DEALS = '/apis/v1/seat_deals/?flavour=mobile';
export const LOG_FE_METRIC = '/apis/fe/metric/?flavour=v2'
